import { createAsyncThunk } from '@reduxjs/toolkit';
import { Hexabase } from 'hexabase-sdk';
import { Condition } from 'hexabase-sdk/dist/models';
import { machineService } from '../../services/index';
import { MachineRequest, newItemEquipment, t_equipment_lease } from '../../types';

export const getListMachine = createAsyncThunk<any, { pageNumber: number; searchValue?: MachineRequest | undefined }>(
  'machine/getItems',
  async (params) => {
    try {
      const consditions: Condition[] = [];
      params.searchValue?.lease_start_date &&
        consditions.push({
          search_value: params.searchValue?.lease_start_date,
          data_type: 'datetime',
          id: 'lease_start_date',
          exact_match: false,
          include_null: true,
        });
      params.searchValue?.lease_end_date &&
        consditions.push({
          search_value: params.searchValue.lease_end_date,
          data_type: 'datetime',
          id: 'lease_end_date',
          exact_match: false,
          include_null: true,
        });
      params.searchValue?.lease_contract_date &&
        consditions.push({
          search_value: params.searchValue.lease_contract_date,
          data_type: 'datetime',
          id: 'lease_contract_date',
          exact_match: false,
          include_null: true,
        });
      params.searchValue?.lease_company &&
        consditions.push({
          search_value: [params.searchValue.lease_company],
          data_type: 'text',
          id: 'lease_company',
          exact_match: false,
          include_null: true,
        });
      params.searchValue?.machine_quantity &&
        consditions.push({
          search_value: params.searchValue.machine_quantity,
          data_type: 'number',
          id: 'machine_quantity',
          exact_match: false,
          include_null: true,
        });
      params.searchValue?.lease_contract_id &&
        consditions.push({
          search_value: ['(?i)' + String(params.searchValue.lease_contract_id)],
          data_type: 'text',
          id: 'lease_contract_id',
          exact_match: false,
          include_null: true,
        });
      const MachineLeaseItems = await Hexabase.items().getItemsAsync({
        project_id: 'CPAP',
        datastore_id: 't_equipment_lease',
        per_page: 20,
        page: params.pageNumber,
        use_display_id: true,
        sort_field_id: 'lease_contract_id',
        sort_order: 'asc',
        conditions: params.searchValue ? consditions : undefined,
      });
      return MachineLeaseItems;
    } catch (error) {
      console.log(error);
    }
  },
);

export const getDataStoreFieldsMachine = createAsyncThunk<any, { appId: string; dataStoreId: string }>(
  'register/getDataStoreFields',
  async (params) => {
    const response = await machineService.getDataStoreFieldMachine(params);
    return response;
  },
);

export const getDetailMachine = createAsyncThunk<any, string>('listMachine/getDetailMachine', async (params) => {
  const result = await Hexabase.items().getItemsAsync({
    project_id: 'CPAP',
    datastore_id: 't_equipment_lease',
    per_page: 1,
    page: 1,
    use_display_id: true,
    include_links: true,
    conditions: [
      {
        search_value: [params],
        data_type: 'text',
        id: 'i_id',
        exact_match: true,
        include_null: false,
      },
    ],
  });
  const items = result.items[0] as t_equipment_lease;
  if (!items.item_links?.item_count || items.item_links?.item_count < 1) {
    return items;
  }
  const listLinkId = items.item_links
    ? items.item_links.links[0].items.map((value) => {
        return value.i_id;
      })
    : [];
  const listMachines = await Hexabase.items().getItemsAsync({
    project_id: 'CPAP',
    datastore_id: 't_machine',
    per_page: 0,
    page: 1,
    use_display_id: true,
    sort_field_id: 'created_at',
    include_links: true,
    conditions: [
      {
        search_value: listLinkId,
        data_type: 'text',
        id: 'i_id',
        exact_match: false,
        include_null: false,
      },
    ],
  });

  const fieldsMachine = await machineService.getDataStoreFieldMachine({ appId: 'CPAP', dataStoreId: 't_machine' });
  const optionMachine: any = Object.entries(fieldsMachine.data.fields);
  const arr =
    optionMachine.find(([_key, value]: [string, any]) => value.display_id === 'machine_type')[1].options || [];
  const newMachines =
    listMachines.items.length > 0
      ? listMachines.items.map((data: any) => {
          const result = arr.find((f: any) => f.value === data.machine_type);
          return {
            ...data,
            machine_type: result ? result.display_id : data.machine_type,
            machine_type_name: result ? result.value : '',
          };
        })
      : [];

  return { ...items, machines: newMachines };
});

export const updateMachine = createAsyncThunk<any, newItemEquipment>('listMachine/updateMachine', async (param) => {
  const machineItem = param.machine
    ? param.machine.map((item) => {
        if (!item.i_id) {
          return {
            operation: 1,
            link_to_parent: true,
            item: {
              machine_type: item.machine_type,
              machine_other: item.machine_other,
              machine_serial_number: item.machine_serial_number,
              lease_contract_id: param.item.lease_contract_id,
              machine_remark: item.machine_remark,
            },
          };
        }
        return {
          operation: 2,
          link_to_parent: true,
          i_id: item.i_id,
          item: {
            i_id: item.i_id,
            d_id: item.d_id,
            machine_type: item.machine_type,
            machine_other: item.machine_other,
            machine_serial_number: item.machine_serial_number,
            lease_contract_id: param.item.lease_contract_id,
            rev_no: item.rev_no,
            machine_remark: item.machine_remark,
          },
          is_force_update: true,
        };
      })
    : [];

  const newParam = { ...param, related_ds_items: machineItem };
  const response = await machineService.updateEquiment(newParam);
  return response;
});
